import React, { useEffect, useState } from "react";

const sizeMap = {
  xs: "w-7 h-7 text-[10px]",
  sm: "w-9 h-9 text-xs",
  md: "w-10 h-10 text-xs",
  lg: "w-12 h-12 text-sm",
  xl: "w-16 h-16 text-lg",
};

const Avatar = ({
  name = "",
  src,
  size = "md",
  color,
  online,
  className = "",
}) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [src]);

  const initials = name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const bg = color
    ? { background: `linear-gradient(135deg, ${color}88, ${color})` }
    : { background: "linear-gradient(135deg, #16a34a88, #16a34a)" };

  return (
    <div className={`relative inline-flex flex-shrink-0 ${className}`}>
      {src && !imgError ? (
        <img
          src={src}
          alt={name}
          onError={() => setImgError(true)}
          className={`${sizeMap[size] || sizeMap.md} rounded-full object-cover`}
        />
      ) : (
        <div
          className={`${sizeMap[size] || sizeMap.md} rounded-full flex items-center justify-center font-bold text-white`}
          style={bg}
        >
          {initials}
        </div>
      )}
      {online !== undefined && (
        <span
          className={`absolute right-0 bottom-0 rounded-full border-2 border-white bg-green-600 ${
            size === "xs" || size === "sm" ? "w-2.5 h-2.5" : "w-3 h-3"
          }`}
        />
      )}
    </div>
  );
};

export default Avatar;
